// @ts-nocheck
import * as React from 'react';
import { BoldIcon, ItalicIcon, UnderlineIcon } from 'lucide-react';
import { KEYS } from 'platejs';
import { useEditorReadOnly } from 'platejs/react';
import { RedoToolbarButton, UndoToolbarButton } from './history-toolbar-button';
import { LinkToolbarButton } from './link-toolbar-button';
import { BulletedListToolbarButton, NumberedListToolbarButton } from './list-toolbar-button';
import { MarkToolbarButton } from './mark-toolbar-button';
import { TurnIntoToolbarButton } from './turn-into-toolbar-button';
import { ToolbarEditorGroup } from 'src/components/ui/editor/ui/toolbar-editor';

export function FixedToolbarButtons() {
  const readOnly = useEditorReadOnly();

  return (
    <div className="flex w-full">
      {!readOnly && (
        <>
          <ToolbarEditorGroup className="">
            <UndoToolbarButton />
            <RedoToolbarButton />
          </ToolbarEditorGroup>
          {/*<ToolbarEditorGroup className="">*/}
          {/*  <InsertToolbarButton />*/}
          {/*</ToolbarGroup>*/}
          <ToolbarEditorGroup className="">
            <TurnIntoToolbarButton />
          </ToolbarEditorGroup>
          {/*<ToolbarEditorGroup className="">*/}
          {/*  <FontSizeToolbarButton />*/}
          {/*</ToolbarGroup>*/}
          <ToolbarEditorGroup className="">
            <MarkToolbarButton nodeType={KEYS.bold} tooltip="Bold (⌘+B)">
              <BoldIcon />
            </MarkToolbarButton>

            <MarkToolbarButton nodeType={KEYS.italic} tooltip="Italic (⌘+I)">
              <ItalicIcon />
            </MarkToolbarButton>

            <MarkToolbarButton nodeType={KEYS.underline} tooltip="Underline (⌘+U)">
              <UnderlineIcon />
            </MarkToolbarButton>

            {/*<MarkToolbarButton clear={false}nodeType={KEYS.strikethrough} tooltip="Strikethrough (⌘+⇧+M)">*/}
            {/*  <StrikethroughIcon />*/}
            {/*</MarkToolbarButton>*/}

            {/*<MarkToolbarButton clear={false}nodeType={KEYS.code} tooltip="Code (⌘+E)">*/}
            {/*  <Code2Icon />*/}
            {/*</MarkToolbarButton>*/}

            {/*<FontColorToolbarButton nodeType={KEYS.color} tooltip="Text color">*/}
            {/*  <BaselineIcon />*/}
            {/*</FontColorToolbarButton>*/}

            {/*<FontColorToolbarButton nodeType={KEYS.backgroundColor} tooltip="Background color">*/}
            {/*  <PaintBucketIcon />*/}
            {/*</FontColorToolbarButton>*/}
          </ToolbarEditorGroup>

          <ToolbarEditorGroup className="">
            {/*<AlignToolbarButton />*/}
            <NumberedListToolbarButton />
            <BulletedListToolbarButton />
            {/*<TodoListToolbarButton />*/}
            {/*<ToggleToolbarButton />*/}
          </ToolbarEditorGroup>

          <ToolbarEditorGroup className="">
            {/*@ts-ignore*/}
            <LinkToolbarButton />
            {/*<TableToolbarButton />*/}
            {/*<EmojiToolbarButton />*/}
          </ToolbarEditorGroup>
        </>
      )}
    </div>
  );
}
